import { initializePerformanceMonitoring } from '../sentry-performance-config';
import { captureStartupSmokeTestException, initSentry } from './sentry';

function addPreconnect(href: string) {
  if (!href) return;
  try {
    const origin = new URL(href).origin || href;
    const exists = Array.from(document.querySelectorAll('link[rel="preconnect"]')).some((el) =>
      (el as HTMLLinkElement).href.startsWith(origin)
    );
    if (exists) return;

    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  } catch (_err) {
    // ignore malformed URLs
  }
}

function setupMonitoringPreconnects() {
  // Add preconnect to Supabase host to improve LCP on initial data fetch
  try {
    const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
    if (supabaseUrl) {
      addPreconnect(supabaseUrl);
    }
  } catch (_e) {
    // no-op
  }

  // Add preconnects for common third-parties used on the dashboard
  try {
    // Sentry DSN host if provided
    const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
    if (dsn) {
      addPreconnect(dsn);
    }
    // HubSpot preconnect deferred until advertising consent (script gated in index.html)
  } catch (_e) {
    // no-op
  }
}

function runStartupSmokeTestIfEnabled() {
  if (process.env.REACT_APP_SENTRY_STARTUP_SMOKE_TEST === '1') {
    captureStartupSmokeTestException('bootstrap');
  }
}

function deferPerformanceMonitoring() {
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(() => initializePerformanceMonitoring(), { timeout: 1000 });
    return;
  }
  setTimeout(() => initializePerformanceMonitoring(), 0);
}

export function initializeMonitoring() {
  setupMonitoringPreconnects();
  // Initialize error capture before first render to catch bootstrap failures.
  initSentry();
  runStartupSmokeTestIfEnabled();
  // Defer heavier performance setup to protect startup responsiveness.
  deferPerformanceMonitoring();
}
